import { useEffect, useState } from 'react';

const KEYBOARD_THRESHOLD_PX = 100;

/**
 * Returns bottom padding (px) to apply when the virtual keyboard is open,
 * so content can scroll above the keyboard. Uses visualViewport for iOS and Android.
 */
export function useKeyboardBottomPadding(): number {
  const [paddingBottom, setPaddingBottom] = useState(0);

  useEffect(() => {
    const vv = window.visualViewport;
    if (!vv) return;

    const update = () => {
      const heightDiff = window.innerHeight - vv.height;
      const keyboardOpen = heightDiff > KEYBOARD_THRESHOLD_PX;
      setPaddingBottom(keyboardOpen ? heightDiff : 0);
    };

    update();
    vv.addEventListener('resize', update);
    vv.addEventListener('scroll', update);
    window.addEventListener('resize', update);

    return () => {
      vv.removeEventListener('resize', update);
      vv.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);

  return paddingBottom;
}
